import { Icon } from "@smart/itops-sb-design-system-dom";

export const Empty = ({ message }: { message: string }) => (
  <div>
    <Icon
      name="solidMagnifyingGlass"
      className="bg-black/10 p-[1.3rem] rounded w-[2.2rem] h-[2.2rem]"
    />
    <p className="text-neutral-600 font-semibold mt-4">{message}</p>
  </div>
);
